"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ThreeDoor.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ThreeDoor = function ThreeDoor(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 230.3 235.8"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "3 Door Icon"), _react2.default.createElement("g", {
    className: "3-door",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "side-window",
    d: "M83.9 140.6c0-.4 0-1.5-7.1-17.3-7.6-17-8.1-15.1-10-15.3-.9.1-1.8.6-2.3 1.3-.3.5-1 0-1.2 31-.2 31.2.7 32.6 1.2 33.5.5.8 1.4 1.3 2.3 1.3h.2c1.9 0 2.8-.1 10.2-17.3 1.1-2.5 6.7-15.7 6.7-17.2zM68.8 164c-.1-5.2-.2-13.1-.2-23.6.1-8.8.2-16.5.3-22 3.6 7.8 8.6 19.1 9.7 22.2-1.1 3.3-6.2 15.5-9.8 23.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "side-window-2",
    d: "M153.2 157.9c7.4 17.2 8.4 17.2 10.2 17.3h.1c1 0 1.8-.5 2.3-1.3.5-.8 1.4-2.2 1.2-33.5-.2-30.9-.9-30.4-1.2-31-.5-.8-1.4-1.3-2.3-1.3-2 .2-2.4-1.8-10 15.3-7.1 15.8-7.1 16.9-7.1 17.3 0 1.4 5.6 14.6 6.8 17.2zm-1.5-17.3c1.1-3.1 6-14.4 9.7-22.2.1 5.5.3 13.2.3 22 .1 10.5 0 18.3-.2 23.6-3.5-7.9-8.6-20.1-9.8-23.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "front-window",
    d: "M76.5 100.3l1 2 37.9-.3 38.3.3 1-2c.1-.2 3.1-6.3 5.8-13.3 5.2-13.4 4.9-17.9 3.9-20.4-2.8-7.8-13-20.9-48.8-21.6h-.1c-35.8.7-45.9 13.8-48.8 21.6-.9 2.5-1.3 7 3.9 20.4 2.8 7 5.8 13.1 5.9 13.3zM73.3 69c3.8-10.4 19.2-16.6 42.2-17 23.1.4 38.5 6.6 42.3 17 1 2.6-2.9 14.4-8.5 26.3l-33.6-.3-33.8.3c-5.7-11.9-9.5-23.7-8.6-26.3z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "chasis",
    d: "M229 111.8l-40.2-36.2c-.1-.1-.2-.2-.3-.2l1.6-33.8c0-7-7.2-14.5-11.4-18.3C164.5 10.5 139.4-.3 115.1 0 90.9-.3 65.7 10.5 51.5 23.2 47.2 27 40.1 34.5 40.1 41.5l1.6 33.9-.2.1-40.2 36.3c-1.6 1.5-1.8 4-.3 5.7s4 1.8 5.7.3l35.5-32 5.9 123.8c.1 14.6 11.9 26.3 26.4 26.4h81.1c14.6 0 26.4-11.8 26.4-26.4l6-124 35.6 32.1c1.6 1.5 4.2 1.4 5.7-.3 1.4-1.6 1.3-4.2-.3-5.6zm-72.8-93.7c1.2.7 2.4 1.5 3.7 2.2 10.4 6 13.2 8.8 13.6 10.1-1.4 1.5-11.6 3.8-19.1-.5-4.4-2.5-5.5-11.1-5.6-15.7 1.6.4 4.9 2.4 7.4 3.9zm-95.3 7.4c5.1-3.1 13.2-7.9 17.3-10.4.7-.4 1.4-.7 2.2-.9-.1 4.5-1.2 13.2-5.6 15.7-7.5 4.3-17.7 2-19.1.5.2-.9 1.5-2.3 5.2-4.9zm114.2 183.9c0 10.7-8.7 19.4-19.4 19.4H74.5c-10.7 0-19.4-8.7-19.4-19.4l-8-167.9c0-1.4 1-3.7 3.2-6.7 3 3.6 9.3 4.4 12 4.5.7 0 1.3.1 1.9 0 4.9.1 9.8-1.1 14.1-3.4 9.6-5.5 9.1-21.9 9.1-23.8v-.9c9-2.5 18.4-3.7 27.8-3.5 9-.2 18 .9 26.8 3.2l-.2.3v.9c-.1 3.1.2 6.3.7 9.3 1.3 7.1 4.1 12 8.4 14.4 4.3 2.3 9.2 3.5 14.1 3.4h1.9c2.9-.2 9.8-1 12.6-5.2 2.6 3.3 3.7 5.9 3.7 7.4l-8.1 168z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "back-window",
    d: "M141.6 154.7l-26.6.2h-.2l-26.8-.2-.9 2.3c-5.8 15-12.2 34-10.6 38.7 3.1 8.8 16.8 14.8 35.6 15.7h4.2c19.2-.9 33.5-7.1 36.6-15.7 1.7-4.8-4.8-23.7-10.6-38.7l-.7-2.3zm4.8 38.8c-1.9 4.7-13 10.1-30.2 10.9h-3.7c-16.7-.8-27.3-6.1-29.2-10.9-.3-3.2 4.6-18.4 9.6-31.8l18.2.1v.1h7.4v-.1l18.2-.1c5.1 13.4 10 28.6 9.7 31.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: undefined
  })));
};
exports.default = ThreeDoor;